export default __webpack_public_path__ + "static/resume_Sumit_Pal_2022-e1b2c826e9fffa4f84d2983d7af99f9b.pdf";